import * as assert from 'assert';
import { ApiService } from './ApiService';
import { IUserInfo, UserInfo } from '../models/User';

interface AccountInfoResponse {
    is_ready: boolean;
    user_info: IUserInfo;
}

export class AccountInfo {
    is_ready: boolean;
    user_info: UserInfo;

    public constructor(args: AccountInfoResponse) {
        assert(undefined != args, 'AccountInfo constructor passed null or undefined args object');
        assert(typeof args.is_ready === 'boolean', 'AccountInfo constructor passed args with invalid name');
        assert(null !== args.user_info && typeof args.user_info === 'object',
            'AccountInfo constructor passed args with invalid user_info');

        this.is_ready = args.is_ready;
        this.user_info = new UserInfo(args.user_info);
    }
}

export class UserService extends ApiService {
    protected basePath: string = 'signup';

    public checkAccount(): Promise<AccountInfo> {
        return this.getRequest()
            .then((response: AccountInfoResponse) => {
                if (typeof response.is_ready === 'boolean'
                    && response.user_info !== null
                    && typeof response.user_info === 'object'
                ) {
                    return new AccountInfo(response);
                } else {
                    assert(false, 'UserService checkAccount : unexpected response from server');
                    throw new Error('UserService checkAccount : unexpected response from server');
                }
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/services/UserService.ts